<i18n>
{
  "en": {
    "vip_badge": "VIP",
    "svip_badge": "SVIP",
    "annual_badge": "Annual",
    "limited_tag": "Limited Availability",
    "expired_tag": "Availability Ended",
    "future_tag": "Upcoming"
  },
  "ja": {
    "vip_badge": "VIP",
    "svip_badge": "超VIP",
    "annual_badge": "年間",
    "limited_tag": "期間限定",
    "expired_tag": "配信期間終了",
    "future_tag": "近日配信",
    "more_movies": "もっと見る"
  }
}
</i18n>

<template>
<div class="grid is-movie">
    <!-- movie item -->
    <div v-for="(movie, index) in movieList" :key="movie.MovieID" class="grid-item">
      <router-link
        :to="`/movies/${movie.MovieID}/`"
        :data-category="showCategory"
        :data-movie-id="movie.MovieID"
        :data-movie-title="movie.Title"
        :data-actress-name="movie.Actor"
        class="entry">
        <div class="entry-media">
          <div v-if="!newXPEligible && movie.isVIP" class="tag-member is-vip">{{ $t('vip_badge') }}</div>
          <div v-if="!newXPEligible && movie.isSVIP" class="tag-member is-svip">{{ $t('svip_badge') }}</div>
          <div v-if="!newXPEligible && movie.isAnnual" class="tag-member is-annual">{{ $t('annual_badge') }}</div>
          <div class="media-thum">
            <img class="media-image" :src="`${movie.thumbnailSrc.replace('str_s.jpg', `list1.jpg`)}`"  @error="useFallbackImage(index)" loading="lazy" alt="" v-sfw>
          </div>
        </div>
        <div class="entry-meta">
          <div v-if="movie.IsExpired" class="tag-status is-expired">{{ $t('expired_tag') }}</div>
          <div v-if="movie.IsLimited" class="tag-status is-limited">{{ $t('limited_tag') }}</div>
          <div v-if="movie.IsComingSoon" class="tag-status is-future">{{ $t('future_tag') }}</div>
          <div class="meta-data">{{ movie.Release }}</div>
          <div v-if="locale == 'ja'">
            <div class="meta-title">{{ movie.Title }}</div>
            <div class="meta-data">{{ movie.Actor }}</div>
          </div>
          <div v-if="locale == 'en'">
            <div v-if="movie.TitleEn != null && movie.TitleEn != ''" class="meta-title">{{ movie.TitleEn }}</div>
            <div v-else class="meta-title" v-for="actress in movie.ActressesEn" :key="actress.$index">{{ actress }}</div>
          </div>
        </div>
      </router-link>
    </div>
    <!-- /movie item -->
</div>
</template>

<script>
/* eslint max-len: 0 */

import BifrostAPI from '@/assets/js/services/Bifrost/API';
import MovieHelper from '@/assets/js/utils/movie';

export default {
  props: {
    numMovies: Number,
    showCategory: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      movieList: [],
      categoriesList: [],
      posterFallbackTries: {},
    };
  },
  created() {
    this.getMovies(this.userTypeID);
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    newXPEligible() {
      return this.$store.getters['user/isNewXPEligible'];
    },
    userTypeID() {
      return this.$store.getters['user/typeID'];
    },
  },
  methods: {
    getMovies(userTypeID) {
      const bfAPI = new BifrostAPI();
      bfAPI.getCategories().then((categoryMap) => {
        Object.keys(categoryMap).forEach((categoryId) => {
          if (this.showCategory === categoryMap[categoryId].name.ja) {
            // backend can take an array of category IDs here, so forcing a single element array
            bfAPI.getCategoryList(0, this.numMovies, [parseInt(categoryId, 10)]).then((result) => {
              const movieList = MovieHelper.expandDetailsList(result.Rows, this.locale, userTypeID);
              this.movieList = MovieHelper.filterExcludedMovieList(movieList, userTypeID);
            });
          }
        });
      });
    },
    useFallbackImage(index) {
      // missing movie poster thumbnail, fallback to large poster
      if (!this.posterFallbackTries[this.movieList[index].MovieID]) {
        // attempt 1: poster thumbnail is missing, use large poster
        this.$set(this.movieList[index], 'thumbnailSrc', `/assets/sample/${this.movieList[index].MovieID}/str.jpg`);
        this.posterFallbackTries[this.movieList[index].MovieID] = true;
      } else {
        // attempt 2: large poster is missing, use no-image placeholder
        this.$set(this.movieList[index], 'thumbnailSrc', '/img/common/now_printing_portrait.png');
      }
    },
  },
  watch: {
    userTypeID(newVal) {
      this.getMovies(newVal);
    },
    numMovies(newVal, oldVal) {
      if (newVal !== oldVal) this.getMovies(this.userTypeID);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
